export const categories = [
  {
    slug: 'gaoxiao',
    name: '搞笑',
    icon: 'ri-emotion-laugh-line',
    description: '搞笑段子、幽默短剧、趣味挑战，每天笑不停',
    color: 'primary',
    articleCount: 128,
  },
  {
    slug: 'meishi',
    name: '美食',
    icon: 'ri-restaurant-line',
    description: '美食制作、探店打卡、厨艺教程，满足你的味蕾',
    color: 'accent',
    articleCount: 96,
  },
  {
    slug: 'lvxing',
    name: '旅行',
    icon: 'ri-earth-line',
    description: '旅行Vlog、景点攻略、户外探险，带你环游世界',
    color: 'secondary',
    articleCount: 84,
  },
  {
    slug: 'yinyue',
    name: '音乐',
    icon: 'ri-music-line',
    description: '原创音乐、翻唱演绎、乐器演奏，聆听美妙旋律',
    color: 'primary',
    articleCount: 112,
  },
  {
    slug: 'youxi',
    name: '游戏',
    icon: 'ri-gamepad-line',
    description: '游戏实况、攻略解说、电竞集锦，畅享游戏乐趣',
    color: 'accent',
    articleCount: 156,
  },
  {
    slug: 'zhishi',
    name: '知识',
    icon: 'ri-lightbulb-line',
    description: '科普知识、技能教程、冷知识分享，每天学一点',
    color: 'secondary',
    articleCount: 73,
  },
  {
    slug: 'yundong',
    name: '运动',
    icon: 'ri-run-line',
    description: '健身教程、运动打卡、极限运动，点燃你的活力',
    color: 'primary',
    articleCount: 65,
  },
  {
    slug: 'chongwu',
    name: '宠物',
    icon: 'ri-heart-pulse-line',
    description: '萌宠日常、养护知识、趣味互动，治愈你的每一天',
    color: 'accent',
    articleCount: 89,
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug);
};